<template>
  <section class="section">

    <img id="logo" src="../assets/logo-dark.svg">

    <a-row type="flex" justify="center" align="middle" class="main-row" v-if="invite">

      <a-col :span="8">
        <template v-if="invite">
          <div class="invite-details">
            <h1>Join <span>{{ invite.team_name }}</span><br/>on Outside Voice.</h1>
            <div class="inviter">
              <img v-if="invite.inviter_profile_pic" :src="invite.inviter_profile_pic">
              <p><span>{{ invite.inviter_email }}</span> invited you.</p>
            </div>
          </div>
        </template>
      </a-col>

      <a-col :span="6">

        <a-card title="Create an Outside Voice Account" :bordered="true" style="width: 400px">

          <div v-if="!is_google_loading" id="google-btn" @click="googleSignup"></div>
          <a-spin v-if="is_google_loading" size="large" />

          <hr class="divider"/>

          <a-form
            id="signup-form"
            :form="form"
            class="signup-form"
            @submit="emailSignup"
          >
            <h4 style="margin-bottom:15px">Or sign up with email</h4>
            <a-form-item>
              <a-input
                v-decorator="[
                  'name',
                  {
                    rules: [{ required: true, type: 'string', message: 'Please enter your full name' }],
                    validateTrigger: ['blur']
                  }
                ]"
                placeholder="Full name"
              >
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="[
                  'email',
                  {
                    rules: [{ required: true, type: 'email', message: 'Please enter a valid email' }],
                    validateTrigger: ['blur']
                  }
                ]"
                placeholder="Email"
              >
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="[
                  'password',
                  {
                    rules: [
                      { required: true, message: 'Please input your password' },
                      { min: 6, message: 'Password must be at least 6 characters.' }
                    ],
                    validateTrigger: ['blur']
                  }
                ]"
                type="password"
                placeholder="Password"
              >
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
            <a-form-item>
              <a-checkbox
                v-decorator="[
                  'remember',
                  {
                    valuePropName: 'checked',
                    initialValue: true,
                  }
                ]"
              >
                Remember me
              </a-checkbox>
              <a-button
                v-if="!is_loading"
                type="primary"
                html-type="submit"
                class="signup-form-button"
              >
                Create an Account
              </a-button>

              <center><a-spin v-if="is_loading" size="large" /></center>

              <div v-if="!is_loading">
                Already have an account? <router-link to="/login">Login</router-link>
              </div>

            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>

    <!-- // Loading Invite -->
    <a-spin v-else id="invite-loading" size="large"  />

  </section>
</template>

<script>

import { google_provider, email_provider } from '../services/firebase';
import moment from 'moment';
import { db_helper } from '../store/db_helper.js';

export default {

  beforeCreate () {
    this.form = this.$form.createForm(this);
  },

  data() {
    return {
      invite: undefined,
      is_loading: false,
      is_google_loading: false
    }
  },

  methods: {

    // Signup with Google
    googleSignup(e) {

      this.is_google_loading = true;
      analytics.track('Sign Up Google Clicked');

      this.$auth.signInWithPopup(google_provider).then(async result => {

        analytics.track('Sign Up Google Successful');

        let user = result.user;
        let uid = user.uid;

        let google_data;
        if (user.displayName && user.email) {
          google_data = user;
        } else if (user.providerData && user.providerData[0]) {
          google_data = user.providerData[0];
        };

        // If this is the user's first time logging in with Google (unlikely, but possible), add supplementary info
        try {
          let invite_id = this.$route.query.code;
          await db_helper.addGoogleDataToUserDoc(uid, google_data, invite_id);
          this.is_google_loading = false;
          this.$store.dispatch('initUser', uid);
          this.$router.replace('/surveys');
        } catch (err) {
          console.log(err);
          this.is_google_loading = false;
          this.$message.warning('Whoops there was an error creating your account, please try again', 5);
        };


      // Error logging in with Google
      }).catch(error => {
        console.log(error.code);
        console.log(error.message);
        this.is_google_loading = false;
      });
    },


    // Sign up with Email
    emailSignup(e) {

      e.preventDefault();

      this.is_loading = true;
      analytics.track('Sign Up Email Clicked');

      this.form.validateFields(async (err, values) => {

        let email = values.email;
        let password = values.password;
        let name = values.name;

        if (!err) {

          this.$auth.createUserWithEmailAndPassword(email, password).then(data => {

            analytics.track('Sign Up Email Successful');

            let user = data.user;
            let uid = user.uid;

            let first_name = '';
            let last_name = '';

            if (name) {
              let names = name.split(' ');
              first_name = names[0];
              if (names.length > 1) {
                last_name = names[names.length - 1];
              };
            };

            let user_data = {
              uid,
              email,
              name,
              first_name,
              last_name,
              time_created: moment().unix(),
              phone: "",
              profile_pic: "",
              // flags: {
              //   X: false,
              // }
            };

            // Add newly authed user to firebase and link them to their team
            this.$db.collection("users").doc(uid).set(user_data).then(async () => {
              try {
                let invite_id = this.$route.query.code;
                await this.$axios.put(`https://api-outsidevoice.vercel.app/init-user-account`, { uid, invite_id });
              } catch (err) {};
              this.is_loading = false;
              this.$store.dispatch('initUser', uid);
              this.$router.replace('/surveys');
              return;
            });

          }).catch(error => {  // Invalid sign in - wrong email and/or password or the user already exists in the database

            console.log('email sign up error', error);

            // TODO: Switch the user's account id to the team account id here...

            if (error && error.code === "auth/email-already-in-use") {
              this.$auth.signInWithEmailAndPassword(email, password).then(data => {
                let user = data.user;
                this.is_loading = false;
                this.$store.dispatch('initUser', user.uid); // Save user to the store
                this.$router.replace('/surveys'); // Valid sign in (even though they tried to sign up)
              }).catch(error => {  // Invalid sign in - wrong email and/or password
                this.is_loading = false;
                this.$message.warning('Did you forget your password? Or perhaps you already created an account with Google', 5);
                this.$router.replace('/login'); // User is trying to sign up when they already have an account, they also messed up their pw, move them to login and tell them that.
              });
            };
          });

        } else {
          this.is_loading = false;
        };

      });
    }
  },


  async mounted() {

    let invite_code = this.$route.query.code;
    if (invite_code) {

      let invite = await db_helper.getInvite(invite_code);
      if (invite) {

        const currentUser = this.$auth.currentUser;

        let is_new_user = window.location.href.includes('new');

        // If a pre-existing user, switch their account_id's and redirect.
        if (currentUser && !is_new_user) {
          let uid = currentUser.uid;
          await this.$axios.put(`https://api-outsidevoice.vercel.app/switch-user-account`, { uid, invite_id: invite_code });
          this.$store.dispatch('initUser', uid); // Save user to the store
          let that = this;
          setTimeout(() => {
            that.$router.replace('/surveys#switch');
          }, 2000);

        // New User; Add new to hash for info to persist since Google Signup calls mounted again
        } else {
          window.location.hash = 'new';
          this.invite = invite;
        };

      } else {
        var result = confirm("Looks like this invite code is invalid or has already been used, press ok to return to sign up");
        this.$router.replace('/signup');
      };
    } else {
      this.$router.replace('/signup');
    };
  },

  created() {
    analytics.page('Accept Invite');
  }

};
</script>



<style lang="scss" scoped>
#invite-loading{
  position: fixed;
    top: 50%;
    left: 50%;
}
.main-row{
  height: 100%;
}
section{
  width: 100%;
  height: 100%;
  background-color: RGB(248,248,248);
}

#logo{
  position: absolute;
    left: 50%;
    top: 40px;
  width: 180px;
  transform: translateX(-90px);
}

.invite-details{
  transform: translateY(-100px);
  h1{
    font-size: 40px;
    font-weight: 500;
    span{
      font-weight: 700;
    }
  }
  .inviter{
    display: flex;
    align-items: center;
    margin-top: 30px;
    img{
      height: 40px;
      width: 40px;
      margin-right: 15px;
      border-radius: 20px;
    }
    p{
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 0px;
      color: rgb(30,30,30);
      span{
        font-weight: 700;
      }
    }
  }
}

.invite-already-accepted{
  font-size: 20px;
  text-align: center;
}

#signup-form .signup-form {
  max-width: 300px;
}
#signup-form .signup-form-forgot {
  float: right;
}
#signup-form .signup-form-button {
  width: 100%;
}
#google-btn{
  height: 45px;
  width: 256px;
  background-image: url("../assets/btn-google.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border: none;
  border-radius: 4px;
  &:hover{
    cursor: pointer;
  }
}
.divider{
  border-top: 1px solid rgb(220,220,220);
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
